import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "views/common/Layout";
import { X, Home, Wrench } from "lucide-react";

export const NotFound = () => {
    return (
        <Layout>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
                <div className="mx-auto max-w-3xl">
                    <div className="text-center">
                        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                            Page Not Found
                        </h1>
                        <p className="mt-4 text-lg text-gray-600">
                            The page you're looking for doesn't exist or has
                            been moved.
                        </p>
                    </div>

                    <div className="mt-12 bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
                        <h2 className="text-xl font-semibold text-gray-900 mb-4">
                            What can you do?
                        </h2>
                        <ul className="space-y-4 text-gray-600">
                            <li className="flex items-start">
                                <span className="flex-shrink-0 h-6 w-6 text-blue-500">
                                    1.
                                </span>
                                <span className="ml-2">
                                    Check if you've entered the correct URL
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 h-6 w-6 text-blue-500">
                                    2.
                                </span>
                                <span className="ml-2">
                                    Return to the homepage and navigate from
                                    there
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="flex-shrink-0 h-6 w-6 text-blue-500">
                                    3.
                                </span>
                                <span className="ml-2">
                                    Contact our support team if you need
                                    assistance
                                </span>
                            </li>
                        </ul>
                    </div>

                    <div className="mt-8 text-center space-x-4">
                        <Link
                            to="/"
                            className="inline-flex items-center rounded-lg bg-blue-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            <Home className="w-4 h-4 mr-2" />
                            Return to Home
                        </Link>
                        <Link
                            to="/category"
                            className="inline-flex items-center rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                            <Wrench className="w-4 h-4 mr-2" />
                            Browse Tools
                        </Link>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
